// extracted by mini-css-extract-plugin
module.exports = {"root":"q_bJ","input":"q_b6","label-col":"q_b7","labelCol":"q_b7","label":"q_b8","sublabel":"q_b9","actions":"q_cb","button":"q_by","plus-btn":"q_cc","plusBtn":"q_cc"};